import { c as _c } from "react/compiler-runtime";
import { IconAlertTriangle } from "@tabler/icons-react";
import { getEntry } from "@/lib/contentful/guards";
import { useProduct } from "@/queries/useProduct";
import { usePdpStore } from "@/stores/usePdpStore";
import type { TypeMaterial } from "@/types/contentful/generated";
import { useProductBuilderContext } from "./ProductBuilderContext";
export default function MaterialWarning() {
  const $ = _c(8);
  const {
    product
  } = useProductBuilderContext();
  const {
    data: productAdmin
  } = useProduct(product.sku);
  const selectedMaterial = usePdpStore(_temp);
  const materialValue = selectedMaterial ?? productAdmin?.defaultMaterial;
  let t0;
  if ($[0] !== materialValue || $[1] !== product.materials) {
    const contentfulMaterials = (product.materials ?? []).map(getEntry).filter(_temp2);
    let t1;
    if ($[3] !== materialValue) {
      t1 = material_0 => material_0.fields.sku === materialValue;
      $[3] = materialValue;
      $[4] = t1;
    } else {
      t1 = $[4];
    }
    t0 = contentfulMaterials.find(t1);
    $[0] = materialValue;
    $[1] = product.materials;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  const matched = t0;
  const warningText = product.warningText ?? matched?.fields.warningText;
  if (!warningText) {
    return null;
  }
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <IconAlertTriangle size={18} aria-hidden="true" className="shrink-0 text-amber-600" />;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== warningText) {
    t2 = <div className="flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 p-3">{t1}<p className="text-sm text-amber-800">{warningText}</p></div>;
    $[6] = warningText;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp2(material) {
  return Boolean(material);
}
function _temp(state) {
  return state.material;
}